/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_EyebrowInputs */

const tr_onbilgi_eyebrow = /** @type {(inputs: Onbilgi_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ÖN BİLGİLENDİRME FORMU`)
};

const en_onbilgi_eyebrow = /** @type {(inputs: Onbilgi_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRE-INFORMATION FORM`)
};

const de_onbilgi_eyebrow = /** @type {(inputs: Onbilgi_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VORAB-INFORMATIONSFORMULAR`)
};

const ru_onbilgi_eyebrow = /** @type {(inputs: Onbilgi_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ФОРМА ПРЕДВАРИТЕЛЬНОГО ИНФОРМИРОВАНИЯ`)
};

/**
* | output |
* | --- |
* | "PRE-INFORMATION FORM" |
*
* @param {Onbilgi_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_eyebrow = /** @type {((inputs?: Onbilgi_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_eyebrow(inputs)
	if (locale === "de") return de_onbilgi_eyebrow(inputs)
	if (locale === "ru") return ru_onbilgi_eyebrow(inputs)
	return tr_onbilgi_eyebrow(inputs)
});